import React, { useLayoutEffect, useState } from "react";
import * as API from "src/api/request";
import _ from "lodash";
import { Select } from "antd";
import { useUserContext } from "src/contexts/userContext";
import { usePlanContext } from "src/contexts/planContext";

const Delguur = (props) => {
  const { state, dispatch } = usePlanContext();
  const { user, checkGroup } = useUserContext();
  const [list, setList] = useState([]);
  const { Option } = Select;

  return (
    <Select
      showSearch
      allowClear
      placeholder="Сонгоно уу."
      optionFilterProp="children"
      className="w-full"
      {...props}
    >
      {_.map(_.orderBy(state?.delguur_list, ["delguur_ner"]), (item) => (
        <Select.Option key={item.id} value={item.id}>
          {item.id +
            " - " +
            item.delguur_ner +
            " - " +
            item.d_register +
            " - " +
            item.d_utas}
        </Select.Option>
      ))}
    </Select>
  );
};

export default React.memo(Delguur);
